import { render } from "./AssignmentChat.vue?vue&type=template&id=6c24eb46&scoped=true"
import script from "./AssignmentChat.vue?vue&type=script&lang=js"
export * from "./AssignmentChat.vue?vue&type=script&lang=js"

import "./AssignmentChat.vue?vue&type=style&index=0&id=6c24eb46&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c24eb46"]])

export default __exports__